import React from "react";
import { Link } from "react-router-dom";

export default function FeaturedPost({ article }) {
  return (
    <section className="mu-section pb-0">
      <div className="container">
        <Link to={`/stories/${article.slug}`} className="featured-post">
          <img src={article.heroImage} alt={article.title} />
          <div className="featured-post-body">
            <span className="news-tag">{article.tag}</span>
            <h3>{article.title}</h3>
            <p>{article.excerpt}</p>
            <span className="btn-mu-solid d-inline-block">Read the Story &rarr;</span>
          </div>
        </Link>
      </div>
    </section>
  );
}
